<script setup lang="ts">
import { useRoute } from 'vue-router';
import { Tabbar } from './components/tabbar';
import { ExhibitionCard } from './components/exhibition-card';
import { type Exhibition, getEnterpriseExhibitionList } from '@/api/exhibition';
import { onMounted, ref } from 'vue';
import { LazyContainer } from '@/components';

const route = useRoute();
const enterpriseId = route.params.enterpriseId as string;

const exhibitionList = ref<Exhibition[]>([]);

onMounted(async () => {
  exhibitionList.value = await getEnterpriseExhibitionList({ enterpriseId });
});

</script>

<template>
  <div :class="$style.container">
    <LazyContainer>
      <template v-for="item of exhibitionList" :key="item.id">
        <ExhibitionCard :exhibition="item" />
        <div style="padding: 60px 0 10px;">
          <div :class="$style.divider" />
        </div>
      </template>
    </LazyContainer>
    <Tabbar />
  </div>
</template>

<style module>
.container {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding: 10px 10px 50px;
  overflow: auto;
  height: 100vh;
}

.divider {
  width: 100%;
  height: 15px;
  background-image: url('//cloudknit-3d.oss-cn-shanghai.aliyuncs.com/cdn/image/divider.png');
  background-repeat: repeat-x;
  background-position: center;
  background-size: contain;
}
</style>
